module.exports = __webpack_public_path__ + "img/20250725.af2e5882.jpg";